import React, { useState } from "react";
import { History, CheckCircle2, AlertTriangle, Loader2, ChevronRight } from "lucide-react";
import { CampaignDetailDialog } from "@/components/CampaignDetailDialog";

const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("es-CR", { day: "2-digit", month: "2-digit", year: "numeric" }) +
      " " + d.toLocaleTimeString("es-CR", { hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const CampaignHistory = ({ campaigns, onRefresh }) => {
  const [openId, setOpenId] = useState(null);
  return (
  <div className="mt-8" data-testid="campaign-history">
    <div className="flex items-center gap-2 mb-3">
      <History size={16} className="text-neutral-400" />
      <h3 className="font-display font-bold text-base">Historial de campañas</h3>
    </div>
    {campaigns.length === 0 ? (
      <p className="text-sm text-neutral-400 bg-white rounded-2xl border border-dashed border-neutral-300 px-4 py-6 text-center">
        Todavía no has enviado campañas.
      </p>
    ) : (
      <div className="bg-white rounded-2xl border border-neutral-200 divide-y divide-neutral-100">
        {campaigns.map((c) => (
          <button key={c.id} data-testid={`campaign-row-${c.id}`} onClick={() => setOpenId(c.id)}
            className="w-full text-left px-4 py-3 flex items-center justify-between gap-3 flex-wrap hover:bg-neutral-50 transition-colors max-sm:flex-col max-sm:items-start max-sm:gap-2 max-sm:py-4">
            <div className="min-w-0 max-sm:w-full">
              <p className="font-medium text-sm truncate max-sm:whitespace-normal">{c.subject}</p>
              <p className="text-xs text-neutral-500 mt-0.5">{fmtDate(c.created_at)} · {c.recipients_total} destinatario(s)</p>
            </div>
            <div className="flex items-center gap-2 text-xs max-sm:flex-wrap">
              {c.status === "sending" ? (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 font-medium">
                  <Loader2 size={12} className="animate-spin" /> Enviando {c.sent_count}/{c.recipients_total}
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 font-medium">
                  <CheckCircle2 size={12} /> {c.sent_count} enviados
                </span>
              )}
              {c.failed_count > 0 && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-50 text-red-600 font-medium">
                  <AlertTriangle size={12} /> {c.failed_count} fallidos
                </span>
              )}
              <ChevronRight size={14} className="text-neutral-300 max-sm:hidden" />
            </div>
          </button>
        ))}
      </div>
    )}
    <CampaignDetailDialog campaignId={openId} open={!!openId} onOpenChange={(v) => { if (!v) setOpenId(null); }} onRetried={onRefresh} />
  </div>
  );
};
